import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import CreateEditViewSalesOrder from "../../../components/sales-section/sales-order/create-edit-view-sales-order";
import { useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { salesViewAction } from "../../../redux/actions/sales-action";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";

const AddSales = () => {
  const [searchParams] = useSearchParams();
  const cloneID = searchParams.get("cloneID");
  const isClone = cloneID ? true : false;

  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    setLoading(true);
    dispatch(salesViewAction(cloneID, onSuccPur, onErrPur));
  }, []);

  const onSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };
  console.log("orderDetail================================", orderDetail);
  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout
          backBtn={true}
          title={`${isClone ? "Clone" : "Add"} Sales order`}
        >
          <CreateEditViewSalesOrder
            page="add"
            pageType="sales"
            isClone={isClone}
            orderDetail={orderDetail?.itemData}
            vendorDetails={[orderDetail?.orderData]}
          />
        </InnerLayout>
      )}
    </>
  );
};
export default AddSales;
